// extracted by mini-css-extract-plugin
module.exports = {"LoadingWrapper":"Loading_LoadingWrapper__Nwbki","Loading":"Loading_Loading__6VYty","load4":"Loading_load4___PmqC"};